<template>
    <div v-if="siloData.user.id !== 0" id="pageloader" :data-slide-direction="transitionName">
        <div class="moduleloader">
            <div v-if="currentPageData" class="page module" :class="currentPageData[active_slide].slide_color === 'green' ? 'bg-color--dark' : ''" :data-active-slide="active_slide" :data-slide-color="currentPageData[active_slide].slide_color ? currentPageData[active_slide].slide_color : 'white'" :data-slide-style="currentPageData[active_slide].slide_style ? currentPageData[active_slide].slide_style : 'card'">

                <div class="ms__nav c c--content--pad pad--h r r--row-always r--justify-space-between r--halign-center">
                    <div class="ms__nav__back">
                        <button v-if="active_slide !== 0 && currentPageData[active_slide].hide_back_button !== 'true'" @click="prev" class="ms__back link type--pre-header">Back</button>
                    </div>
                    <div class="ms__nav__title">
                        <span v-if="currentPageData[active_slide].hide_topic_title !== 'true'" class="type--pre-header type--pre-header--bold" v-text="currentPageData[active_slide].ancestors[0].title"></span>
                    </div>
                    <div class="ms__nav__close">
                        <button
                            v-if="currentPageData[active_slide].hide_close_button !== 'true'"
                            @click="close"
                            aria-title="To Home Screen"
                            class="ms__close icon icon--close">
                                <Icon name="close" />
                        </button>
                    </div>
                </div>

                <TransitionGroup :name="transitionName"
                    tag="div" style="height:100%">
                    <div v-for="(slide, index) in currentPageData" 
                        v-show="active_slide === index"
                        class="page__slide" 
                        :class="active_slide === index ? 'active' : 'inactive'"
                        :data-slide="index"
                        :key="index">
                        <PageSlide 
                            :sd="slide" 
                            :index="index" 
                            :slides="currentPageData"
                            :siloData="siloData"
                            :appState="appState"
                            :active_slide="active_slide"
                            :active="active_slide === index ? true : false"
                            @processing="setProcessing"
                            @refreshData="refreshData"
                            @setNextOnRefresh="setNextOnRefresh"
                            @next="next"
                            @prev="prev"
                            @home="home()"
                            @close="close"
                            @restart="restart"
                            @updateState="updateState"
                        />
                    </div>
                </TransitionGroup>
                <div class="ms__bg"></div>
            </div>
        </div>
    </div>
</template>

<script>
import PageSlide from "@c/PageSlide.vue";
import Icon from '@c/Icon.vue'
const axios = require('axios');
export default {
    components: {
        PageSlide,
        Icon,
    },
    data() {
        return {
            state: "inactive",
            currentPageData: null,
            processing: false,
            active_slide: 0,
            anims: {
                loadModuleJS: 550,
                hideSpeedJS: 750,
            },
            transitionName: 'show-next',
            nextOnRefresh: false,
        }
    },
    computed: {
        lastSlide() {
            return this.currentPageData.length - 1;
        },
    },
    props: {
        siloData: Object,
        appState: String,
        pageId: Number,
        active: Boolean,
        activator: String,
    },   
    watch: {
        // Reset the page loader when the app state changes
        // If the app state is not Get Help
        appState() {
            if (this.appState === "home") {
                this.reset();
            }
        },
        active() {
            // This is broken if the person opens directly to the page
            if (this.active === true) {
                console.log('ACTIVE PAGE');
                if (this.currentPageData !== null) {
                    //this.postPageView();
                }
            }
        },
        siloData() {
            console.log('pageloader: silo data changed');
            if (this.nextOnRefresh !== true) { return }
            console.log('pageloader: can do next on refresh');
            if (this.active === true) {
                console.log('pageloader: can do next');
                this.next();
            }
        },
    },
    mounted() {
        // We just load all the pages when we mount
        // because there's nothing dynamic
        this.loadPages();

        // Remove this after I figure out page navigation better
        window.pageLoader = this;
    },
    methods: {
        // Pull a page and it's children
        loadPages() {
            if (this.pageId === null) return;
            //console.log('loading page', this.pageId);

            // I had to make this URL static because it loads before the silodata is loaded
            // I need to make a second set of data that is just static data
            axios.post(this.siloData.urls.getpage, {
                id: this.pageId,
            }).then((result) => {
                //console.log('current page data', result.data);
                
                this.currentPageData = result.data.slice(1);
                //this.active_slide = this.currentPageData[0].slug;
                this.state = 'active';

                // Check to see if we have an active slide string
                // this.checkForSlideQueryString();
                
            }).catch((reason) => {
                console.log(reason);
            });
        },
        // Go back to first page
        home() {
            this.transitionName = "show-prev";
            this.active_slide = 0;
            this.postPageView();
        },
        set(slug) {
            this.transitionName = "show-next";
            this.active_slide = slug;
            this.postPageView();
        },
        next() {
            /*
            if (this.nextOnRefresh === true) {
                this.nextOnRefresh = false;
            }
            */
           console.log('emitting next on page loader');
            this.transitionName = 'show-next';
            this.active_slide += 1;
            //this.$emit('refreshData');
            /*
            this.trackProgression();
            this.updateUrl();
            this.postPageView();
            this.stopTimer();
            this.startTimer();
            */
        },
        prev() {
            /*
            if (this.nextOnRefresh === true) {
                this.nextOnRefresh = false;
            }
            */
            this.transitionName = 'show-prev';
            this.active_slide -= 1;
            /*
            this.trackProgression();
            this.updateUrl();
            this.postPageView();
            this.stopTimer();
            this.startTimer();
            */
        },
        close() {
            this.reset();
            this.$emit('close');
        },
        restart() {
            // comment this out if we want it to animate to the next at the end for starting over
            this.transitionName = 'show-prev';
            this.animateSlidesBackwards();
            // uncheck this if we don't want to animate
            //this.active_slide = 0;
        },
        async animateSlidesBackwards() {
            let wait = 50;
            let current_count = this.currentPageData.length;
            for (let i = 0; i < current_count; i++) {
                this.active_slide -= 1;
                await new Promise(r => setTimeout(r, wait));
            }
        },
        reset() {
            //console.log('reseting page loader');
            // Set as inactive
            this.state = "inactive";
            // Set active slide back to the first
            //this.active_slide = this.currentPageData[0].slug;
            this.active_slide = 0;
        },
        setNextOnRefresh() {
            console.log('setting next on refresh (page loader)');
            this.nextOnRefresh = true;
        },
        setProcessing(state) {
            console.log('setting processing (page loader)');
            this.$emit('processing', state);
        },
        refreshData(onComplete = null) {
            console.log('refreshing data (page loader)');
            this.$emit('refreshData', onComplete);
        },
        postPageView() {

            let data = {
                type: 'page',
                title: this.currentPageData[this.active_slide].title,
            };
            console.log('posting page view', data);
            window.events.postPageView(data);
        },
        updateState(newState) {
            this.$emit('updateState', newState);
        }
    } 
}
</script>

<style lang="scss" scoped>
@import "@s/_mixins.scss";
@import "@s/_vars.scss";
#pageloader {
    display: flex;
        width: 100%;
    height: 100%;
}
.pageloader {

}
.moduleloader {
    transform: translateY(0) !important;
}
.page {
    height: 100%;
    transition: all 0.15s;
    &[data-slide-style="takeover"] {
        .ms__bg {
            border-radius: 0 !important;
        }
    }
    &[data-slide-color="green"] {
        .ms__bg {
            background-color: var(--color-sp-green);
        }
    }
    &[data-slide-color="white"] {
        .ms__bg {
            background-color: var(--color-offwhite);
        }
    }
    &[data-slide-color="blue"] {
        .ms__bg {
            background-color: var(--color-sp-stardust);
        }
    }
}
.page__slide {
    width: 100vw;
    height: 100%;
    position: absolute;
    > * {
        width: 100vw;
    }
}
</style>